export const cst = {
  scenes: {
    boot: "boot",
    preload: "preload",
    login: "login",
    signup: "signup",
    sendemail: "sendemail",
    resetpassword: "resetpassword",
    gui: "gui",
    menu: "menu",
    intro: "intro",
    categories2: "categories2",
    categories3: "categories3",
    categories4: "categories4",
    categories5: "categories5",
    categories6: "categories6",
    board: "board",
    rules: "rules",
    questions: "questions",
    pause: "pause",
    endCategories: "endCategories",
    end: "end",
    questionstest: "questionstest",
  },

  textstyles: {
    question: {
      fontFamily: "Arial",
      fontSize: "28px",
      color: "#000",
      wordWrap: { width: 575 },
    },
    answer: {
      fontFamily: "Arial",
      fontSize: "26px",
      color: "#000",
      wordWrap: { width: 505 },
    },
    timer: { fontFamily: "Arial", fontSize: "66px", color: "#000" },
    points: { fontFamily: "Arial", fontSize: "40px", color: "#3e3e3e" },
    score: { fontFamily: "Arial", fontSize: "200px", color: "#3e3e3e" },
    end: { fontFamily: "Arial", fontSize: "100px", color: "#3e3e3e" },
    "category-header": {
      fontFamily: "Arial",
      fontSize: "48px",
      color: "#3e3e3e",
    },
    "category-1": { fontFamily: "Arial", fontSize: "40px", color: "#bf0f5c" },
    "category-2": { fontFamily: "Arial", fontSize: "40px", color: "#ea5431" },
    "category-3": { fontFamily: "Arial", fontSize: "40px", color: "#f2ba13" },
    "category-4": { fontFamily: "Arial", fontSize: "40px", color: "#23a3dd" },
    "category-5": { fontFamily: "Arial", fontSize: "40px", color: "#073b5b" },
  },
};
